import { get, post } from "../../utills/BaseService";


export async function getAllLog(dispatch: any,input:any): Promise<any> {
    return await post(dispatch, '/auditLog/getAllLog', input)
};